import type { ISummaryChart } from './SummaryDialog.types'
import type { SummaryReportItem } from '@/models/catalogConfig'
import type CatalogPriceGroup from '@/models/catalogPriceGroup'
import { isDefined, isValidStringValue } from '@/services/utils'

const validChartTypes = new Set(['vbar', 'hbar', 'pie'])

export function getSummaryCharts(summaryReportConfig: SummaryReportItem[], availableAttributes: Record<string, IMyAttribute>, priceGroups: { retail?: CatalogPriceGroup, wholesale?: CatalogPriceGroup, outlet?: CatalogPriceGroup }) {
  const charts: ISummaryChart[] = []
  if (summaryReportConfig && summaryReportConfig.length) {
    summaryReportConfig.forEach((summaryReport, index) => {
      if (isValidStringValue(summaryReport.chartType) && validChartTypes.has(summaryReport.chartType.toLowerCase())
        && isDefined(summaryReport.dataRange1) && isValidStringValue(summaryReport.dataRange1.articleProperty)
        && isDefined(availableAttributes[summaryReport.dataRange1.articleProperty])) {
        const dataRange1Attribute = availableAttributes[summaryReport.dataRange1.articleProperty]
        let dataRange1AttributeLabel = dataRange1Attribute.DisplayName
        if (dataRange1Attribute.SystemName === '_WholesalePrice' && priceGroups.wholesale) {
          dataRange1AttributeLabel += ` (${priceGroups.wholesale.CurrencyCode})`
        }
        else if (dataRange1Attribute.SystemName === '_RetailPrice' && priceGroups.retail) {
          dataRange1AttributeLabel += ` (${priceGroups.retail.CurrencyCode})`
        }
        else if (dataRange1Attribute.SystemName === '_OutletPrice' && priceGroups.outlet) {
          dataRange1AttributeLabel += ` (${priceGroups.outlet.CurrencyCode})`
        }
        let chartTitle = isValidStringValue(summaryReport.chartTitle) ? summaryReport.chartTitle : dataRange1AttributeLabel
        let isValid = true
        if (isDefined(summaryReport.dataRange2)) {
          if (isDefined(summaryReport.dataRange2.articleProperty) && isDefined(availableAttributes[summaryReport.dataRange2.articleProperty])) { // if contains articleProperty do not consider formula
            const dataRange2Attribute = availableAttributes[summaryReport.dataRange2.articleProperty]
            if (!isValidStringValue(summaryReport.chartTitle)) {
              chartTitle = `${dataRange1AttributeLabel} (Sum of ${dataRange2Attribute.DisplayName})`
            }
          }
          else if (isValidStringValue(summaryReport.dataRange2.formula)) {
            if (!isValidStringValue(summaryReport.chartTitle)) {
              chartTitle = `${dataRange1AttributeLabel} (Sum of a formula)`
            }
          }
          else {
            isValid = false
            console.warn(`Invalid entry in SummaryReport configuration, ${summaryReport.dataRange2.articleProperty ? `"${summaryReport.dataRange2.articleProperty}" in dataRange2 is not a valid attribute` : ''}, ${(summaryReport.dataRange2.formula && summaryReport.dataRange2.formula.toString().trim() !== '') ? `"${summaryReport.dataRange2.formula}" in dataRange2 is not a valid formula` : ''}`)
          }
        }
        if (isValid && chartTitle) {
          const chartId = `${summaryReport.dataRange1.articleProperty}-${index}`
          charts.push({
            id: chartId,
            title: chartTitle,
            type: summaryReport.chartType,
            dataRange1: summaryReport.dataRange1,
            dataRange2: summaryReport.dataRange2,
            direction: isDefined(summaryReport.groupBySortDirection) && summaryReport.groupBySortDirection.trim().toLowerCase() === 'descending' ? -1 : 1,
          })
        }
      }
      else {
        console.warn(`Invalid entry in SummaryReport configuration, either "chartType" is missing or contains invalid value or "${summaryReport && summaryReport.dataRange1 ? summaryReport.dataRange1.articleProperty : 'undefined'}" in dataRange1 is not a valid attribute`)
      }
    })
  }
  return charts
}
